// extracted by mini-css-extract-plugin
module.exports = {"container":"info_container__1Ma3O","icon":"info_icon__32zq8","title":"info_title__2SYHo"};